import { createRouteRef } from '@backstage/frontend-plugin-api';

export const spogRouteRef = createRouteRef();
